/**
 * Dar Alameria — single source of truth for the villa promo surfaces.
 *
 * Dar Alameria is a private 5-suite estate in Marrakech let by the same owner
 * as Route Facile. Its own site lives on a separate subdomain; this file holds
 * only the facts the car-rental site needs to advertise a stay, so the nav
 * badge, the home-page band and any future page can never disagree.
 *
 * Every figure below is taken from the property's published listing
 * (airbnb.com/rooms/51019148). `nightly` is the per-night rate for the WHOLE
 * estate, derived from the published seven-night price (EUR 7,252 / 7). Treat
 * it as indicative — the villa site links out to live rates, and the wording
 * around it ("from") must stay conditional. If the listing changes, change it
 * here and nowhere else.
 */
export const DAR_ALAMERIA = {
  url: "https://daralameria.routefacilecarrental.com",
  whatsapp:
    "https://api.whatsapp.com/send?phone=212655585859?text=" +
    encodeURIComponent(
      "Hello! I would like information about staying at Dar Alameria in Marrakech."
    ),
  nightly: 1036,
  currency: "\u20ac",
  suites: 5,
  guests: 10,
  baths: 8,
  hectares: 1,
  livingSqm: 1000,
  rating: "4.78",
  reviews: 9,
};

export default DAR_ALAMERIA;
